import FormResultReplacer from './../../form-result-replacer/js/form-result-replacer.component';
import RegisterToBidFormComponent from './register-to-bid-form.component';
import ComponentsCollection from "../../../general/js/components-collection";

export default class RegisterToBidFormReplacer extends FormResultReplacer {

    createFormInstance() {
        return ComponentsCollection.getInstance().createComponent(this.element, 'register-to-bid-form', RegisterToBidFormComponent, {onSuccess: this.onFormSuccess.bind(this)});
    }
}



// WEBPACK FOOTER //
// ./app/components/register-to-bid/js/register-to-bid-replacer.component.js